import { connect } from 'react-redux';

import useMartyContext from 'hooks/useMartyContext';
import { deleteHeartList } from 'actions/hearts';
import MelodyModal from 'components/common/MelodyModal';

import css from 'styles/components/account/collectionModals/deleteCollectionModal.scss';

export const DeleteCollectionModal = ({
  showDeleteCollectionModal,
  onDoneModal,
  deleteHeartList,
  listId,
  content = {
    heading: 'Delete List',
    message: 'Are you sure you want to delete this List?'
  },
  isInfluencerCollection = false
}) => {
  const { testId } = useMartyContext();
  const { heading, message } = content;
  const onDeleteCollection = () => {
    deleteHeartList(listId, isInfluencerCollection).then(onDoneModal);
  };

  return (
    <MelodyModal
      className={css.modal}
      heading={heading}
      headingTestId="deleteCollectionHeader"
      isOpen={showDeleteCollectionModal}
      onRequestClose={onDoneModal}
    >
      <div>
        <p data-test-id={testId('deleteModalText')}>{message}</p>
        <div className={css.footer}>
          <button type="button" onClick={onDoneModal} data-test-id={testId('cancelDeleteCollectionButton')}>
            Cancel
          </button>
          <button type="button" onClick={onDeleteCollection} data-test-id={testId('deleteCollectionButton')}>
            Delete
          </button>
        </div>
      </div>
    </MelodyModal>
  );
};

export default connect(() => ({}), {
  deleteHeartList
})(DeleteCollectionModal);
